import { Center, Spinner } from "@chakra-ui/react";

export const LoaderSpinner = () => {
  return (
    <Center>
      <Spinner size="xl" />
    </Center>
  );
};
